import { render, staticRenderFns } from "./Demolition.vue?vue&type=template&id=f848f9d4&"
import script from "./Demolition.vue?vue&type=script&lang=js&"
export * from "./Demolition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports